<template>
  <div direction="right" class="default-slider space-top-lg">
    <div class="slider-inner space-top-lg" style="width:55%; z-index: 9;" v-if="!isEmptyData">
      <div class="slider-header">
        <span>
          {{metaData.entity_no}} Details
        </span>
        <div class="header-action" v-if="metaData.entity_type===exceptionType.INDENTS">
          <router-link class="link-action" :to="goToIndentsPage">
            <span> {{$t('EXCEPTION_GO_TO_INDENT')}} </span>
          </router-link>
        </div>
      </div>
      <div class="slider-body p-0">
        <div v-if = "columnType !== EXCEPTION_TYPE.INEGRATION">
        <ElTabs class="tab-default tab-sm tab-bg no-bg" v-model="activeTab">
          <Tab-pane label="Vehicle Exception" name="1">
            <div class="tab-content">
              <div class="content-scroll space-top-lg mx-pd-15" style="width:55%;">
                <Table
                  :data="truckData"
                  :stripe="true"
                  :max-height="windowHeight"
                  class="table-striped bordered-outline"
                  aria-describedby="exceptionTruckData"
                  >
                   <table-column
                    v-for="header in truckHeaders"
                    :key="header.id"
                    :prop="header.col"
                    :label="header.name"
                    :width="header.width">
                  </table-column>
                  <table-column
                   v-for="header in truckHeaderDates"
                    :key="header.id"
                    :label="header.name"
                    :prop="header.col"
                    :width="header.width"
                  >
                    <template slot-scope="scope">
                      <div>{{scope.row[header.col].date}}</div>
                      <div>{{scope.row[header.col].time}}</div>
                    </template>
                   </table-column>
                   <table-column
                    v-for="header in truckDeviationHeader"
                    :key="header.id"
                    :prop="header.col"
                    :label="header.name"
                    :width="header.width">
                  </table-column>
                </Table>
              </div>
            </div>
          </Tab-pane>
          <Tab-pane label="Material Exception" name="2">
            <div class="tab-content">
              <div class="content-scroll-inner space-top-lg mx-pd-15" style="width:55%;">
                <Table
                  :data="materialData"
                  :stripe="true"
                  :max-height="windowHeight"
                  class="table-striped bordered-outline"
                  aria-describedby="exceptionMaterialData"
                  >
                 <table-column
                    v-for="header in materialHeaders"
                    :key="header.id"
                    :prop="header.col"
                    :label="header.name"
                    :width="header.width">
                  </table-column>
                  <table-column
                   v-for="header in materialHeaderDates"
                    :key="header.id"
                    :label="header.name"
                    :prop="header.col"
                    :width="header.width"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row[header.col].date">
                        <div>{{scope.row[header.col].date}}</div>
                        <div>{{scope.row[header.col].time}}</div>
                      </div>
                      <div v-else>
                        <div>{{scope.row[header.col]}}</div>
                      </div>
                    </template>
                   </table-column>
                   <table-column
                    v-for="header in materialDeviationHeader"
                    :key="header.id"
                    :prop="header.col"
                    :label="header.name"
                    :width="header.width">
                  </table-column>
                </Table>
              </div>
            </div>
          </Tab-pane>
          <Tab-pane label="Halt Exception" name="3" v-if="metaData.entity_type===exceptionType.INDENTS">
            <div class="tab-content">
              <div class="content-scroll-inner space-top-lg mx-pd-15" style="width:55%;">
                <Table
                  :data="haltData"
                  :stripe="true"
                  :max-height="windowHeight"
                  class="table-striped bordered-outline"
                  aria-describedby="exceptionHaltData"
                  >
                  <table-column
                    v-for="header in haltHeaders"
                    :key="header.id"
                    :prop="header.col"
                    :label="header.name"
                    :width="header.width">
                  </table-column>
                </Table>
              </div>
            </div>
          </Tab-pane>
        </ElTabs>
      </div>
    </div>
  </div>
  <div class="slider-inner space-top-lg" style="width:55%; z-index: 9;" v-else-if="!isMetaDataEmpty">
    <div v-if ="columnType === EXCEPTION_TYPE.INEGRATION">
    <div class="slider-header">
        <span>
          {{ metaData.entity_id}} : {{ metaData.api_name}}
        </span>
        <div v-if="metaData.erp_retry_requested">
        <Button
            class="btn"
            @click="add()"
            >{{$t('INDENT_RETRIGGER')}}</Button>
        </div>
    </div>
        <div class="slider-body p-0">
                <ElTabs class="tab-default tab-sm tab-bg no-bg" v-model="activeTab">
                    <Tab-pane :label="$t('INDENT_INTEGRATION_LOG')" name="1">
                        <div class="tab-content">
                            <div class="content-scroll space-top-lg mx-pd-15" style="width:55%;">
                                <Table
                                  :data="integrationData"
                                  :stripe="true"
                                  class="table-striped bordered-outline"
                                  aria-describedby="exceptionIntegrationData"
                                  >
                                      <table-column
                                          v-for="header in integrationDetailsHeaders"
                                          :key="header.id"
                                          :prop="header.col"
                                          :label="header.name"
                                          :width="header.width">
                                      </table-column>
                                      <table-column>
                                        <template slot-scope="scope">
                                          <Tooltip :open-delay="100" effect="dark" placement="top-end">
                                          <i class="action-icon" @click="getPayload()">
                                            <a class = 'download-file'></a>
                                            <svgicon name="download-icon" width="15" height="15"/>
                                          </i>
                                          <div slot="content">Download</div>
                                        </Tooltip>
                                        </template>
                                      </table-column>
                                </Table>
                            </div>
                        </div>
                    </Tab-pane>
                </ElTabs>
           </div>
      </div>
  </div>

    <div v-else class="slider-inner space-top-lg" style="width:55%; z-index: 9;">
      <div class="status-msg">
        <span>
          <svgicon name="empty-timeline" width="180" height="130" :original="true" />
          <p class="ml-30">Select an entity to view deviation details</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies, no-unused-vars
import moment from 'moment';
import LoaderCommon from '@common/asset/images/loader-common.gif';

import {
  materialHeaders,
  materialHeaderDates,
  materialDeviationHeader,
  truckHeaders,
  truckHeaderDates,
  truckDeviationHeader,
  haltHeaders,
  integrationDetailsHeaders,
  EXCEPTION_TYPE,
} from '@/constants/exception-data';
import { exceptionType } from 'pando-constants';

export default {
  name: 'exception-slider',
  props: {
    entityData: {
      type: Object,
    },
    metaData: {
      type: Object,
    },
    columnType: {
      type: Number,
    },
  },
  computed: {
    windowHeight() {
      return `${window.innerHeight - 295}px`;
    },
    goToIndentsPage() {
      return {
        name: 'OrderDetailsV2',
        params: {
          orderId: this.metaData && this.metaData.entity_no,
          category: this.metaData && this.metaData.entity_category,
        },
        query: { isEximRoute: 'false' },
      };
    },
    isMetaDataEmpty() {
      if (this.metaData && this.metaData.api_name) return false;
      return true;
    },
    isEmptyData() {
      if (this.entityData) return false;
      return true;
    },
    materialData() {
      if (!this.isEmptyData && this.entityData && this.entityData.material_deviation) {
        return this.entityData.material_deviation.map((deviation) => {
          if (deviation.type === 'Material Invoice') {
            if (deviation.actual) {
              return this.calculateDifference(deviation);
            }
            // for items with no actuals - adding '-'
            return {
              ...deviation,
              expected: moment(deviation.expected).isValid() ? {
                date: deviation.expected ? this.formatDate(deviation.expected).split('-')[0] : '-',
                time: deviation.expected ? this.formatDate(deviation.expected).split('-')[1] : '',
              } : deviation.expected,
              actual: {
                date: '-',
                time: '',
              },
              deviation: '-',
            };
          }
          return deviation;
        });
      } return [];
    },
    truckData() {
      if (!this.isEmptyData &&
        this.entityData.truck_deviation &&
        this.entityData.truck_deviation.length) {
        return this.entityData.truck_deviation.map((deviation) => {
          if (deviation.actual) {
            return this.calculateDifference(deviation);
          }
          // for items with no actuals - adding '-'
          return {
            ...deviation,
            expected: moment(deviation.expected).isValid() ? {
              date: deviation.expected ? this.formatDate(deviation.expected).split('-')[0] : '-',
              time: deviation.expected ? this.formatDate(deviation.expected).split('-')[1] : '',
            } : deviation.expected,
            actual: {
              date: '-',
              time: '',
            },
            deviation: '-',
          };
        });
      } return [];
    },
    haltData() {
      if (!this.isEmptyData && this.entityData.halts && this.entityData.halts.length) {
        return this.entityData.halts.map(halts => ({
          ...halts,
          from_time: halts.from_time ? this.formatDate(halts.from_time) : '-',
          to_time: halts.to_time ? this.formatDate(halts.to_time) : '-',
        }));
      } return [];
    },
    integrationData() {
      let arr = [];
      if (!this.isMetaDataEmpty) {
        arr = [this.metaData];
      } return arr;
    },
  },
  data() {
    return {
      LoaderCommon,
      materialHeaders,
      materialHeaderDates,
      materialDeviationHeader,
      truckHeaders,
      truckHeaderDates,
      truckDeviationHeader,
      haltHeaders,
      integrationDetailsHeaders,
      activeTab: '2',
      exceptionType,
      EXCEPTION_TYPE,
    };
  },
  methods: {
    async getPayload() {
      let result = '';
      if (this.metaData) {
        const tmsTransactionId = this.metaData.tms_transaction_id;
        result = await this.$store.dispatch('order/getMitmPayload', { tmsTransactionId });
      }
      if (result && result.error) {
        this.$errorMessage({ message: result.error });
      }
    },
    calculateDifference(deviation) {
      const duration = moment.duration(moment(deviation.expected).diff(moment(deviation.actual)));
      const days = (parseInt(duration.get('days'), 10) !== 0) ? parseInt(duration.get('days'), 10) : null;
      const hours = (parseInt(duration.get('hours'), 10) !== 0) ? parseInt(duration.get('hours'), 10) : null;
      const minutes = (parseInt(duration.get('minutes'), 10) !== 0) ? parseInt(duration.get('minutes'), 10) : null;
      const isNegative = moment(deviation.expected) < moment(deviation.actual);
      let formattedDeviationString = '';
      formattedDeviationString += isNegative ? '-' : '';
      if (days) { formattedDeviationString += `${Math.abs(days)} days `; }
      if (hours) { formattedDeviationString += `${Math.abs(hours)} hours `; }
      if (minutes) { formattedDeviationString += `${Math.abs(minutes)} minutes`; }
      return {
        ...deviation,
        deviation: formattedDeviationString,
        expected: moment(deviation.expected).isValid() ? {
          date: deviation.expected ? this.formatDate(deviation.expected).split('-')[0] : '-',
          time: deviation.expected ? this.formatDate(deviation.expected).split('-')[1] : '',
        } : deviation.expected,
        actual: moment(deviation.actual).isValid() ? {
          date: deviation.actual ? this.formatDate(deviation.actual).split('-')[0] : '-',
          time: deviation.actual ? this.formatDate(deviation.actual).split('-')[1] : '',
        } : deviation.actual,
      };
    },
    formatDate(dateString) {
      return moment(dateString).format('MMM Do YYYY  - hh:mm A');
    },
    async add() {
      if (this.metaData) {
        const data = {
          entity_id: this.metaData.entity_id,
          api_name: this.metaData.api_name,
        };
        await this.$store.dispatch('order/retryRequest', { data });
      }
    },
  },
};
</script>
<style scoped>
.default-slider .slider-inner.space-top-lg{
  top: 237px !important;
}
</style>
